import React from 'react';
import { Route, IndexRoute } from 'react-router';
import { App } from './components/app';
import HomeRoute from './screens/Home/index';
import AreasRoute from './screens/Areas/index';
import AboutRoute from './screens/About/index';
import ContactRoute from './screens/Contact/index';
import TestimonialsRoute from './screens/Testimonials/index';

export default (
  <Route path="/" component={App}>
    {HomeRoute}
    {AreasRoute}
    {AboutRoute}
    {ContactRoute}
    {TestimonialsRoute}
  </Route>
);



// WEBPACK FOOTER //
// ./app/screens/App/index.js